import { useCallback } from 'react';
import { useTrackLink } from '../../tracking/useNinja';
import trackingKeys from '../../tracking/trackingKeys';

const { myDeliveries } = trackingKeys.touchPointPages;

const useSafeDealLinkEventTracking = (
  eventName: string,
  adId: string,
  touchPointPage: string = myDeliveries,
): ((callback: () => void, extraData?: Record<string, string | number>) => void) => {
  const callbackTimeout = 1000;

  const trackLink = useTrackLink();

  return useCallback(
    (callback, extraData = {}) =>
      trackLink(
        eventName,
        callback,
        {
          ad_id: adId,
          touch_point_page: touchPointPage,
          ...extraData,
        },
        callbackTimeout,
      ),
    [eventName, adId, trackLink, touchPointPage],
  );
};

export default useSafeDealLinkEventTracking;
